import { useEffect, useRef, useState } from 'react'
import { LandingIcon } from './icons'
import styles from './EngagementWheel.module.css'

export function EngagementWheel() {
  const artwork = useRef<HTMLDivElement>(null)
  const [spinning, setSpinning] = useState(false)

  useEffect(() => {
    const preference = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    const stopMotion = () => {
      if (preference?.matches) setSpinning(false)
    }
    preference?.addEventListener('change', stopMotion)
    return () => preference?.removeEventListener('change', stopMotion)
  }, [])

  useEffect(() => {
    if (!artwork.current || !('IntersectionObserver' in window)) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return
        if (!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches)
          setSpinning(true)
        observer.disconnect()
      },
      { threshold: 0.55 }
    )
    observer.observe(artwork.current)
    return () => observer.disconnect()
  }, [])

  function spin() {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return
    setSpinning(true)
  }

  return (
    <div ref={artwork} className={styles.artwork}>
      <span className={styles.label}>DEMONSTRAÇÃO DA ROLETA</span>
      <div className={styles.wheel} aria-hidden="true">
        <div
          className={`${styles.rotor}${spinning ? ` ${styles.spinning}` : ''}`}
          onAnimationEnd={() => setSpinning(false)}
        >
          <LandingIcon name="sparkle" className={styles.star} />
          <LandingIcon name="sparkle" className={styles.secondStar} />
        </div>
        <span className={styles.pointer} />
        <div className={styles.center}>
          <img src="/logo/sortee.png" alt="" width="2089" height="753" />
        </div>
      </div>
      <button
        type="button"
        className={styles.spinButton}
        aria-label="Girar roleta de demonstração"
        aria-disabled={spinning}
        onClick={() => {
          if (!spinning) spin()
        }}
      >
        <LandingIcon name="refresh" className={styles.spinIcon} />
        <span aria-live="polite">{spinning ? 'Girando…' : 'Girar a roleta'}</span>
        <span className={styles.demo}>DEMONSTRAÇÃO</span>
      </button>
    </div>
  )
}
